var video_viewer_default = {
  "video_player": "_8Dond",
  "videoOverlay": "oqB8n",
  "video_container": "oVQ4V"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
